import { BASENAME } from '@hugendubel/react-basic';

export const AppRoutes = {
    base: BASENAME,
    authorize: '/authorize',
    token: '/token',
    revoke: '/revoke',
};

const ePublishing = (command: string): string => 'epublishing://' + command;

export const ExternalRoutes = {
    TOLINO_REQUEST_AUTH: ePublishing('requestauth'),
    TOLINO_LIBRARY: ePublishing('library'),
    TOLINO_AUDIO_BOOK_LIBRARY: ePublishing('audiobook-library'), // ATTENTION: Only for tolino apps (not eInk devices)
};
